import Badge from "ds/components/Badge";
import { IconComponent } from "types/Icon";

import styles from "./styles.module.css";

type EnvironmentPreviewVariableBadgeProps = {
  text: string;
  icon?: IconComponent;
};

const EnvironmentPreviewVariableBadge = ({ text, icon }: EnvironmentPreviewVariableBadgeProps) => {
  return (
    <Badge
      variant="gray"
      className={styles.badge}
      startIcon={icon}
      text={text}
      textEllipsis
      type="weak"
    />
  );
};

export default EnvironmentPreviewVariableBadge;
